export default function GeozonesViewTableController(
  $scope,
  $stateParams,
  $uibModal,
  $state,
  equipmentGeozoneService,
  gettextCatalog,
) {
  'ngInject';

  $scope.maxEmails = 10;
  $scope.geozoneDetailsBreadcrumb = '';
  $scope.existingGeozoneMsg = '';
  $scope.geozoneNameExists = false;
  $scope.validNameCharacters = '[a-zA-Z0-9\\_\\-\\(\\) ]*';

  $scope.$on('totalEmails', function (event, totalEmails) {
    $scope.maxEmails = totalEmails.length;
  });
  /**
         -- Edit/Cancel Button --
     */
  $scope.editButtonClicked = function (editing) {
    if (editing === true) {
      //Edit Button clicked, so store a copy of the data model
      $scope.backup = angular.copy($scope.geozone);
      $scope.editErrorFlag = false;
      $scope.editSuccessFlag = false;
    } else {
      //Cancelled, so copy data back
      $scope.geozone = $scope.backup;
      $scope.geozoneNameExists = false;
    }
  };

  /**
      -- Delete Button --
  */
  $scope.deleteButtonPressed = function () {
    var modalInstance = $uibModal.open({
      animation: true,
      template: require('../delete-modal/delete.html'),
      controller: [
        '$scope',
        '$uibModalInstance',
        'geozoneData',
        '$stateParams',
        'equipmentGeozoneService',
        'gettextCatalog',
        function (
          $scope,
          $uibModalInstance,
          geozoneData,
          $stateParams,
          equipmentGeozoneService,
          gettextCatalog,
        ) {
          $scope.geozone = geozoneData;

          $scope.ok = function () {
            $scope.deleting = true;
            equipmentGeozoneService.deleteEquipmentGeozone($stateParams.geozoneId).then(
              function (response) {
                $scope.deleting = false;
                $state.go('alerts.geozone.list');
              },
              function (error) {
                var errorMsg = gettextCatalog.getString(
                  'An error occurred while deleting the GeoZone',
                );
                if (error.data || error.status) {
                  if (error.data.message) {
                    errorMsg = error.data.message + ' ' + error.status.toString();
                  } else {
                    errorMsg += ': ' + error.status.toString();
                  }
                } else {
                  errorMsg += gettextCatalog.getString('. Please try again later.');
                }
                $scope.deleteErrorFlag = true;
                $scope.deleteErrorText = errorMsg;
                $scope.deleting = false;
              },
            );
          };

          $scope.cancel = function () {
            $uibModalInstance.close();
          };

          $scope.$on('$locationChangeStart', function (event, next, current) {
            $scope.cancel();
          });
        },
      ],
      resolve: {
        geozoneData: function () {
          return $scope.geozone;
        },
      },
      size: 'md',
    });
  };

  $scope.isFormValid = function (geozoneDetailsForm) {
    $scope.geozoneDetailsForm.$setSubmitted();

    if (geozoneDetailsForm.$invalid || geozoneDetailsForm.$error.maxlength) {
      $scope.loading = false;

      return;
    }
    $scope.onGeozoneEdit('form');
  };

  /**
         -- Save Button --
     */
  $scope.onGeozoneEdit = function (source) {
    $scope.editErrorFlag = false;
    $scope.editSuccessFlag = false;
    equipmentGeozoneService.getGeozoneByName($scope.geozone.name).then(
      function (response) {
        $scope.sending = false;
        if (!$scope.backup) {
          $scope.backup = angular.copy($scope.geozone);
        }
        if ($scope.backup.name == response.data.name) {
          saveEditedGeozone(source);
        } else {
          showGeoZoneNameError();
        }
      },
      function (error) {
        //Expecting to see a 404(Not Found) here
        if (error.status == 404) {
          if (!$scope.backup) {
            $scope.backup = angular.copy($scope.geozone);
          }
          saveEditedGeozone(source);
        } else {
          var errorMsg = gettextCatalog.getString('An error occurred while editing the GeoZone');
          if ((error.data || error.status) && !response.status == 404) {
            if (error.data.message) {
              errorMsg = error.data.message + ' ' + error.status.toString();
            } else {
              errorMsg += ': ' + error.status.toString();
            }
          } else {
            errorMsg += gettextCatalog.getString('. Please try again later.');
          }
          $scope.editErrorFlag = true;
          $scope.editErrorText = errorMsg;
          $scope.postingEdit = false;
        }
      },
    );
  };

  function showGeoZoneNameError() {
    $scope.geozoneNameExists = true;
    $scope.existingGeozoneMsg = gettextCatalog.getString(
      "The name '{{ gname}}' already exists. Please rename the GeoZone. ",
      {
        gname: $scope.geozone.name,
      },
    );
  }

  function saveEditedGeozone(source) {
    $scope.geozoneNameExists = false;
    var toSubmit;
    if (source === 'map') {
      toSubmit = angular.copy($scope.backup);
      toSubmit.geometry = $scope.geozone.geometry;
    }
    if (source === 'form') {
      toSubmit = angular.copy($scope.geozone);
      toSubmit.geometry = $scope.backup.geometry;
    }
    var tags = toSubmit.tags;
    toSubmit.tags = [];
    for (var i = 0; i < tags.length; i++) {
      toSubmit.tags.push(tags[i].text);
    }
    if (toSubmit.alertRule.contacts.length <= $scope.maxEmails) {
      //A quick hack to make sure users can only input maximum 10 email addresses
      $scope.postingEdit = true;

      equipmentGeozoneService.putGeozoneById($stateParams.geozoneId, toSubmit).then(
        function (response) {
          if (source === 'map') {
            $scope.backup.geometry = $scope.geozone.geometry;
          }
          if (source === 'form') {
            $scope.isEditing = false;
          }
          $scope.editSuccessFlag = true;
          $scope.postingEdit = false;
        },
        function (error) {
          var errorMsg = gettextCatalog.getString('An error occurred while editing the GeoZone');
          if (error.data || error.status) {
            if (error.data.message) {
              errorMsg = error.data.message + ' ' + error.status.toString();
            } else {
              errorMsg += ': ' + error.status.toString();
            }
          } else {
            errorMsg += gettextCatalog.getString('. Please try again later.');
          }
          $scope.editErrorFlag = true;
          $scope.editErrorText = errorMsg;
          $scope.postingEdit = false;
        },
      );
    }
  }

  var refresh = function () {
    $scope.loading = true;
    equipmentGeozoneService
      .getGeozoneById($stateParams.geozoneId)
      .then(
        function (response) {
          $scope.geozone = response.data;
          $scope.$emit('$viewContentLoaded'); //fix for breadcrumbs updating
          $scope.$broadcast('name-provided', {
            name: $scope.geozone.name ? $scope.geozone.name : null,
          });
          //set breadcrumb to the name of the geozone
          $scope.geozoneDetailsBreadcrumb = $scope.geozone.name;

          if ($scope.geozone.alertRule.contacts[0].email == '') {
            $scope.geozone.alertRule.contacts = [];
          }
          if ($scope.geozone.alertRule.priority) {
            $scope.geozone.alertRule.priority = $scope.geozone.alertRule.priority.toLowerCase();
          } else {
            $scope.geozone.alertRule.priority = '';
          }
        },
        function (error) {
          var errorMsg = gettextCatalog.getString('An error occurred while retrieving the GeoZone');
          if (error.data || error.status) {
            if (error.data.message) {
              errorMsg = error.data.message + ' ' + error.status.toString();
            } else {
              errorMsg += ': ' + error.status.toString();
            }
          } else {
            errorMsg += gettextCatalog.getString('. Please try again later.');
          }
          $scope.onLoadErrorText = errorMsg;
          $scope.onLoadErrorFlag = true;
        },
      )
      .finally(function (result) {
        $scope.loading = false;
      });
  };
  refresh();
}
